import { useEffect } from "react";

export function Sabilytics() {
  useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.sabilytics.com/script.js";
    script.setAttribute("data-site", "l4c6q3wxjv19");
    script.setAttribute("data-domain", "dabojohnson.netlify.app");
    document.head.appendChild(script);
  }, []);

  return null;
}
